export default __webpack_public_path__ + "static/media/Collab10.9b4b829a.png";